export type OfferCategory = "restaurant" | "bar" | "leisure" | "services" | "alpedhuez" | "lesdeuxalpes" | "lesrousses";
export const OfferCategories = new Set(["restaurant", "bar", "leisure", "services", "alpedhuez", "lesdeuxalpes", "lesrousses"]);
import labels from "./categories.json";
export { labels };
